import carSpacesOptions from './carSpacesOptions';
import energyEfficiencyOptions from './energyEfficiencyOptions';
import { tenureTypeObjects } from '../../../../shared/model/constants/tenureType';
import type { FilterOptionType } from '../../../../shared/model/constants/filterTypes';

export const BUY_PRICE_RANGES: number[] = [
  100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 600000, 700000, 800000,
  900000, 1000000, 1250000, 1500000, 2000000, 2500000, 3000000, 4000000, 5000000, 10000000,
  25000000, 50000000, 100000000,
];

export const SOLD_PRICE_RANGES: number[] = [
  100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 600000, 700000, 800000,
  900000, 1000000, 1250000, 1500000, 2000000, 2500000, 3000000, 4000000, 5000000, 10000000,
  25000000, 50000000, 100000000,
];

export const FORLEASE_PRICE_RANGES: number[] = [
  5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 60000, 70000, 80000, 90000,
  100000, 150000, 200000, 250000, 500000, 1000000, 2000000,
];

export const FLOOR_AREA_RANGES: number[] = [
  50, 100, 150, 200, 250, 300, 350, 400, 500, 750, 1000, 1500, 2000, 3000, 5000, 10000, 20000,
];

export const LAND_AREA_RANGES: number[] = [
  100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 3000, 4000, 5000, 10000, 20000,
  50000, 100000, 500000,
];

export const tenureTypesOptions: FilterOptionType[] = Object.values(tenureTypeObjects).map(
  (tenureTypeObject) => ({
    label: tenureTypeObject.displayText,
    value: tenureTypeObject.key,
  }),
);

export const carSpacesFilterOptions: FilterOptionType[] = carSpacesOptions.map((option) => ({
  label: option.displayText,
  value: option.value.toString(),
}));

export const nabersEnergyRatingFilterOptions: FilterOptionType[] = energyEfficiencyOptions.map(
  (option) => ({
    label: option.displayText,
    value: option.value.toString(),
  }),
);
